<template>
    <div id="index">
        <system-message
            :success="success"
            :message="message"
            class="uk-container"
            @close="clearSystemMessage"
        />
        <div
            v-if="isUserAdmin"
            class="uk-section"
        >
            <div
                class="search-container panel uk-container uk-container-small uk-padding uk-background-muted"
            >
                <form-wrapper
                    :validator="$v.form"
                >
                    <div class="uk-search uk-width-1-1">
                        <div class="uk-flex search-form">
                            <text-field
                                v-model="form.search"
                                icon="search"
                                class="uk-search-input uk-form-width-medium uk-flex-1"
                                placeholder="Find a transaction"
                                :v="$v.form.search"
                                @onEnter="getList(1)"
                            />
                            <div>
                                <a
                                    class="uk-button uk-button-primary"
                                    @click="getList(1)"
                                >Search</a>
                            </div>
                        </div>
                    </div>
                </form-wrapper>
            </div>
        </div>
        <div class="results uk-padding">
            <div
                :class="{ 'uk-flex uk-flex-bottom uk-flex-between': !isDeviceSmall, 'uk-margin-small-bottom': isDeviceSmall }"
            >
                <div class="uk-flex-left">
                    <div class="uk-flex uk-flex-middle">
                        <div class="uk-margin-right">
                            <div v-if="searchTerm">
                                <header class="uk-text-large">
                                    Showing transactions matching "{{ searchTerm }}".
                                    <a @click="clearSearch">
                                        Cancel
                                    </a>
                                </header>
                            </div>
                            <div class="uk-flex-left">
                                <div class="uk-flex-inline uk-margin-small-right">
                                    <div
                                        v-if="isAdvancedFilterEnabled"
                                        class="uk-flex-inline"
                                    >
                                        <div>
                                            <advanced-filter
                                                v-model="selectedFilters.statuses"
                                                header="Status"
                                                :no-selected-text="statusNoSelectedText"
                                                :options="filters.statuses"
                                                :sentence-case="true"
                                                :activated="isFilterKeyActivated('statuses')"
                                            />
                                        </div>
                                        &nbsp;
                                        <div>
                                            <header class="uk-text-large">
                                                payments of
                                            </header>
                                        </div>
                                        &nbsp;
                                        <div>
                                            <advanced-filter
                                                v-model="selectedFilters.paymentTypes"
                                                header="Payment Type"
                                                no-selected-text="any type"
                                                :lower-case="true"
                                                :options="filters.paymentTypes"
                                                :activated="isFilterKeyActivated('paymentTypes')"
                                            />
                                        </div>
                                        &nbsp;
                                        <div>
                                            <header class="uk-text-large">
                                                made by
                                            </header>
                                        </div>
                                        &nbsp;
                                        <div>
                                            <advanced-filter
                                                v-model="selectedFilters.paymentMethods"
                                                header="Payment Method"
                                                no-selected-text="any method"
                                                :lower-case="true"
                                                :options="filters.paymentMethods"
                                                :activated="isFilterKeyActivated('paymentMethods')"
                                            />
                                        </div>
                                        &nbsp;
                                        <div>
                                            <header class="uk-text-large">
                                                in
                                            </header>
                                        </div>
                                        &nbsp;
                                        <div>
                                            <advanced-filter
                                                v-model="selectedFilters.states"
                                                header="State"
                                                no-selected-text="any state"
                                                :options="filters.states"
                                                :activated="isFilterKeyActivated('states')"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="!isAdvancedFilterEnabled && isFilterApplied"
                                        class="uk-flex-inline"
                                    >
                                        <div>
                                            <header class="uk-text-large">
                                                Showing
                                            </header>
                                        </div>
                                        &nbsp;
                                        <div>
                                            <advanced-filter
                                                v-model="selectedFilters.statuses"
                                                header="Status"
                                                :lower-case="true"
                                                :no-selected-text="statusNoSelectedText"
                                                :options="filters.statuses"
                                                :enable-dropdown="false"
                                                :activated="isFilterKeyActivated('statuses')"
                                            />
                                        </div>
                                        &nbsp;
                                        <div>
                                            <header class="uk-text-large">
                                                payments
                                            </header>
                                        </div>
                                        &nbsp;
                                        <div v-if="isFilterKeyActivated('states')">
                                            <header class="uk-text-large">
                                                in
                                            </header>
                                        </div>
                                        &nbsp;
                                        <div v-if="isFilterKeyActivated('states')">
                                            <advanced-filter
                                                v-model="selectedFilters.states"
                                                header="State"
                                                no-selected-text="any state"
                                                :options="filters.states"
                                                :enable-dropdown="false"
                                                :activated="isFilterKeyActivated('states')"
                                            />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <header class="uk-text-large">
                                            {{ statusNoSelectedText }} payments
                                        </header>
                                    </div>
                                </div>
                                <div
                                    v-if="isUserAdmin && !isDeviceSmall"
                                    class="uk-flex-inline"
                                >
                                    <button-with-icon
                                        v-if="isAdvancedFilterEnabled"
                                        class="uk-margin-small-right"
                                        label="Apply"
                                        uk-icon="icon: check"
                                        @click="getList(1)"
                                    />
                                    <button-with-icon
                                        v-if="isAdvancedFilterEnabled"
                                        label="Clear---"
                                        uk-icon="icon: close"
                                        @click="disableAdvancedFilter"
                                    />
                                    <button-with-icon
                                        v-if="!isAdvancedFilterEnabled"
                                        label="Filter"
                                        uk-icon="icon: bolt"
                                        @click="enabledAdvancedFilter"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isDeviceSmall">
                    <hr>
                </div>
                <div
                    v-if="isUserAdmin && isTableShown && !isAdvancedFilterEnabled"
                    class="uk-flex"
                    :class="{ 'uk-flex-right': !isDeviceSmall, 'uk-margin-small-bottom': isDeviceSmall }"
                >
                    <div>Quick filters:</div>
                    <div>&nbsp;</div>
                    <div>
                        <quick-filter-button
                            label="Pending"
                            :selected="isFilterValueEnabled('statuses', 'pending')"
                            @click="toggleQuickFilter('statuses', 'pending')"
                        />
                    </div>
                    <div
                        v-if="filters.states.length > 0"
                        class="divider uk-margin-small-left uk-margin-small-right"
                    />
                    <div
                        v-for="state in filters.states"
                        :key="state.value"
                    >
                        <quick-filter-button
                            :label="state.name"
                            :selected="isFilterValueEnabled('states', state.value)"
                            color="#00d160"
                            class="uk-margin-small-right"
                            @click="toggleQuickFilter('states', state.value)"
                        />
                    </div>
                </div>
            </div>
            <div v-if="!isDeviceSmall">
                <br>
            </div>
            <div v-if="isTableShown && payments.length">
                <payment-list-table
                    :payments="payments"
                    :deposit-list="depositList"
                    :filters="filters"
                    :timezone="timezone"
                    @edit="goToEdit"
                    @getReceipt="getReceipt"
                    @updateSort="updateSort"
                    @changeStatus="showChangePaymentStatusModal"
                    @resendPaymentLink="resendPaymentLink"
                />
                <pagination
                    :pagination="pagination"
                    @setPage="getList"
                />
            </div>
            <div v-else>
                No results found.
            </div>

            <p
                v-if="$device.small"
                class="uk-margin-top uk-text-small uk-text-muted"
            >
                To generate a deposit list PDF, please use a desktop device.
            </p>
        </div>
        <deposit-list-modal
            container="#index"
            @getDepositSlip="getDepositSlip"
        />
        <change-payment-status-modal
            ref="changePaymentStatusModal"
            :payment-statuses="paymentStatuses"
            container="#change-payment-status"
            @setSystemMessage="setSystemMessage"
        />
    </div>
</template>

<script>

import { updateErrorModal } from '@strangeanimals/common-vue-components/src/helpers/api';
import { getDepositSlipLinkRequest, getReceiptLinkRequest, paymentListRequest, getPaymentFormDropdownItemsRequest, resendBpoinPaymentLinkRequest} from '../../helpers/api'
import { isArrayEmpty, sortByKey } from '@strangeanimals/common-vue-components/src/helpers/helpers';
import { mapActions, mapGetters } from 'vuex';
import router from '../../helpers/router'

const ButtonWithIcon  = () => import("../generic/ButtonWithIcon");
const QuickFilterButton  = () => import('../generic/QuickFilterButton');
const AdvancedFilter  = () => import( "../generic/AdvancedFilter");
const Pagination = () => import("@strangeanimals/common-vue-components/src/components/list/Pagination");
const PaymentListTable  = () => import( "../generic/PaymentListTable");
const TextField  = () => import( "@strangeanimals/common-vue-components/src/components/fields/TextField");
const SystemMessage  = () => import( "@strangeanimals/common-vue-components/src/components/page/SystemMessage");
const DepositListModal  = () => import( "../modals/DepositListModal");
const ChangePaymentStatusModal  = () => import( "../modals/ChangePaymentStatusModal");

export default {
    name: 'IndexPage',
    components: {
        AdvancedFilter,
        ButtonWithIcon, DepositListModal, Pagination, TextField, SystemMessage, PaymentListTable, QuickFilterButton,
        ChangePaymentStatusModal
    },
    data: function () {
        return {
            form: {
                search: '',
            },
            success: true,
            message: [],
            searchTerm: '',
            filters: {
                receivedBy: [],
                paymentTypes: [],
                paymentMethods: [],
                states: [],
                statuses: []
            },
            selectedFilters: {
                receivedBy: [],
                paymentTypes: [],
                paymentMethods: [],
                states: [],
                statuses: []
            },
            sortConfig: {
                column: 'date',
                direction: 'desc'
            },
            isAdvancedFilterEnabled: false,
            paymentStatuses: {},
        };
    },
    computed: {
        ...mapGetters({
            pagination: 'pagination',
            itemsPerPage: 'itemsPerPage',
            payments: 'payments',
            loggedInUser: 'user',
            isUserAdmin: 'isUserAdmin',
            depositList: 'depositList',
            serverTimezone: 'serverTimezone'
        }),
        isFilterApplied() {
            let result = false;
            for (const key in this.selectedFilters) {
                if(!isArrayEmpty(this.selectedFilters[key])) {
                    result = true;
                    break;
                }
            }
            return result;
        },
        isDeviceSmall() {
            return this.$device.small;
        },
        statusNoSelectedText() {
            let result = 'Your';
            if (this.isUserAdmin) {
                result = 'All';
            }
            return result;
        },
        isTableShown() {
            return (this.pagination.total > 0) || this.isFilterApplied;
        },
        timezone() {
            return this.serverTimezone ? this.serverTimezone : 'local'
        }
    },
    mounted() {
        this.getList(1);
        this.getPaymentFormDropdownItems();
    },
    validations: {
        form: {
            search: {},
        }
    },
    methods: {
        ...mapActions({
            updatePayments: 'updatePayments',
            updatePagination: 'updatePagination',
            updateActivePage: 'updateActivePage',
            updateActivePaymentID: 'updateActivePaymentID',
            clearDepositList: 'clearDepositList',
            updateServerTimezone: 'updateServerTimezone'
        }),
        getList(page) {
            const data = {
                search: this.form.search,
                page: page,
                itemsPerPage: this.itemsPerPage,
                filters: this.selectedFilters,
                sort: this.sortConfig
            };
            paymentListRequest(data).then((response) => {
                if ((response.status === 200)) {
                    this.success = true;
                    this.message = [];
                    this.updatePayments(response.body.items);
                    this.updatePagination(response.body.pagination);
                    this.filters = response.body.filters;
                    this.updateServerTimezone(response.timezone);
                }
                else {
                    this.success = false;
                    this.message = ['There\'s an error in fetching the payment list.'];
                    this.updatePayments([]);
                    this.filters = {};
                }
                this.searchTerm = this.form.search;
            });
        },
        goToEdit(paymentID) {
            this.updateActivePaymentID(paymentID);
            router.replace('/edit')
        },
        getReceipt(paymentID) {
            const self = this;
            const data = {
                printedBy: this.loggedInUser.id
            };
            getReceiptLinkRequest(paymentID, data).then((response) => {
                if (response.status === 200) {
                    if (response.body.exists) {
                        window.open(response.body.pdf, '_blank');
                    }
                    else {
                        self.setSystemMessage(["Payment not found"], false);
                    }
                }
                else {
                    self.setSystemMessage(["Failed to get receipt."], false);
                    updateErrorModal({ message: response.body.message, status: response.status }).then();
                }
            });
        },
        resendPaymentLink(paymentToken) {
            const self = this;
            resendBpoinPaymentLinkRequest(paymentToken).then((response) => {
                if (response.body.success) {
                    self.setSystemMessage(["Payment link sent."], true);
                }
                else {
                    self.setSystemMessage(["Paymnet link not sent."], false);
                    updateErrorModal({ message: response.body.message, status: response.status }).then();
                }
            });
        },
        getDepositSlip() {
            const self = this;
            const data = {
                printedBy: this.loggedInUser.id,
                paymentIDs: this.depositList.join(",")
            };

            this.$uikit.modal('#deposit-list-modal').hide();
            getDepositSlipLinkRequest(data).then((response) => {
                if (response.status === 200) {
                    if (response.body.exists) {
                        self.clearDepositList();
                        self.getList(1);
                        window.open(response.body.pdf, '_blank');
                    }
                    else {
                        self.setSystemMessage(["An error was encountered"], false);
                    }
                }
                else {
                    self.setSystemMessage(["Failed to get the deposit slip."], false);
                    updateErrorModal({ message: response.body.message, status: response.status }).then();
                }
            });
        },
        setSystemMessage(message, isSuccess) {
            this.message = message;
            this.success = isSuccess;
        },
        clearSystemMessage() {
            this.message = [];
            this.success = true;
        },
        clearSearch() {
            this.searchTerm = "";
            this.form.search = "";
            this.getList(1);
        },
        updateSort(data) {
            this.sortConfig = data.sortConfig;
            this.getList(1);
        },
        isFilterKeyActivated (key) {
            return this.selectedFilters[key].length > 0;
        },
        isFilterValueEnabled (key, value) {
            return this.selectedFilters[key].some((item) => (item.value === value));
        },
        toggleQuickFilter(key, value) {
            if (this.isFilterValueEnabled(key, value)) {
                this.selectedFilters[key] = this.selectedFilters[key].filter((item) => (item.value !== value));
            } else {
                let selectedFilter = this.filters[key].find((item) => (item.value === value));
                if (selectedFilter) {
                    this.selectedFilters[key].push(selectedFilter);
                }
            }
            this.getList(1);
        },
        enabledAdvancedFilter() {
            this.isAdvancedFilterEnabled = true;
        },
        disableAdvancedFilter() {
            this.selectedFilters = {
                receivedBy: [],
                paymentTypes: [],
                paymentMethods: [],
                states: [],
                statuses: []
            };
            this.isAdvancedFilterEnabled = false;
            this.getList(1);
        },
        quickFilterClass(filterName, value) {
            let result = 'undefined';
            if (this.isFilterValueEnabled(filterName, value)) {
                result = 'selected';
            }
            return result;
        },
        getPaymentFormDropdownItems() {
            const self = this;
            getPaymentFormDropdownItemsRequest().then((response) => {
                self.paymentStatuses = sortByKey(response.body.paymentStatuses);
            });
        },
        showChangePaymentStatusModal(data) {
            this.$refs.changePaymentStatusModal.showModal(data);
        },
    }
}
</script>

<style lang="scss">

@import "../../scss/variables.scss";

.divider {
    width: 1px;
    background: $colour-medium-grey;
}

</style>